<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/131/base.png" alt="" />
            <div class="technological-process">
                <div class="rhtj mar-t2">
                    <img
                        class="top"
                        src="./../assets/imgs/xllh/rcgyysq_zcjj.png"
                        alt=""
                    />
                    <div class="content">
                        为大力吸引和集聚青年科技人才，按照"人才新政12条”“人才新政2.0版”，对企业新引进、符合条件的博士研究生发放安家补贴。
                    </div>
                </div>
                <div class="zccl">
                    <img
                        class="top"
                        src="./../assets/imgs/131/label1.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des">
                            <div class="title">需同时满足以下条件：</div>
                            <div >
                              1.取得博士学历学位的高校毕业生【国（境）外高校毕业的博士人员，提供国家教育部留学服务中心出具的学历学位认证书】。
                            </div>
                            <div style="margin-top: 0.35rem;">
                              2.在本市各级市场监督管理部门依法登记、具有独立法人资格，纳税关系在本市，属于我市重点产业链“链主企业”及上下游重点产业企业（以下简称重点企业）新引进的博士研究生。
                            </div>
                            <div style="margin-top: 0.35rem;">
                              3.从本市行政区域外引进到重点企业工作，并与其签订3年及以上劳动合同或聘用合同（合同签订单位须与社保缴纳单位名称一致)。
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zccl" >
                    <img
                        class="top"
                        src="./../assets/imgs/131/label2.png"
                        alt=""
                    />
                    <div class="content" style="background-color: #fff;">
                          从引进的次月起3年内，给予2000元/月的安家补贴，共计7.2万元。
                    </div>
                </div>

                <div class="gmlc">
                    <img
                        class="top"
                        src="./../assets/imgs/131/label3.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="des mar-t3">
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">1</div>
                                    <div class="line-title">集中申请</div>
                                </div>
                                <div class="line-content">
                                  年度申报通知发放后，由企业通过“成都市急需紧缺人才服务管理系统”申报，并向单位注册地所在区（市)县人力资源和社会保障部门提供以下材料:
                                  <div style="font-weight: bolder;margin-top: 0.2rem;">
                                    1.成都市企业引进急需紧缺专业技术人才安家补贴申请表》；
                                  </div>
                                  <div style="font-weight: bolder;margin-top: 0.2rem;">
                                    2.企业营业执照原件及复印件，属于重点企业的证明材料原件及复印件；
                                  </div>
                                  <div style="font-weight: bolder;margin-top: 0.2rem;">
                                    3.被引进人才的身份证（或护照)、毕业证书、学历学位证书、职称证书、劳动合同或聘用合同的原件及复印件；
                                  </div>
                                  <div style="font-weight: bolder;margin-top: 0.2rem;">
                                    4.被引进人才的社保缴纳证明等。
                                  </div>
                                </div>
                            </div>
                            <div class="line-item">
                                <div class="line"></div>
                                <div class="line-top">
                                    <div class="line-num">2</div>
                                    <div class="line-title">区（市）县初审推荐</div>
                                </div>
                                <div class="line-content">
                                </div>
                            </div>

                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line" style="height: 140%;"></div>
                                    <div class="line-num">3</div>
                                    <div class="line-title" style="text-wrap: nowrap;">市级有关行业主管部门复核</div>
                                </div>
                                <div class="line-content"></div>
                            </div>
                            <div class="line-item">
                                <div class="line-top">
                                    <div class="line-num">4</div>
                                    <div class="line-title">公示确认</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="zccl" style="margin-top: 0.8rem;">
                    <img
                        class="top"
                        src="./../assets/imgs/131/label4.png"
                        alt=""
                    />
                    <div class="content" style="background-color: #fff;font-weight: bolder;">
                      按照每年度通知时间确定。
                    </div>
                </div>
                <div class="contact" style="margin-top: 0.3rem">
                    <img
                        class="top"
                        src="./../assets/imgs/25/title-5.png"
                        alt=""
                    />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-61888121">028-61888121</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            成都市人力资源和社会保障局<br />
                            专业技术人员服务管理处
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/131/code.png" />
                    <img class="info" src="../assets/imgs/131/info.png" />
                </div>
            </div>
        </section>
        <call phone="028-61888121"></call>
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() {},

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;
    padding-top: 0.3rem;

    .top-img {
        width: 7.26rem;
        height: 5.6rem;
    }

    .technological-process {
        transform: translateY(-1.9rem);

        .rhtj {
            position: relative;

            .top {
                width: 6.86rem;
                height: 1.12rem;
            }

            .content {
                width: 6.85rem;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                background: #ffffff;
                font-size: 0.26rem;
                color: #4e4e4e;
                text-align: left;
                position: relative;
                font-weight: 500;
                line-height: 0.44rem;
            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: left;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 3.92rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .gmlc {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.86rem;
                background: #e8eeff;
                margin: -0.55rem auto;
                padding: 0 0.33rem 0.35rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.3rem 0.23rem;
                    font-size: 0.26rem;
                    font-weight: 500;
                    color: #4e4e4e;
                    line-height: 0.44rem;

                    .line-item {
                        font-size: 0.26rem;
                        position: relative;
                        z-index: 3;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 130%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .line-title {
                            font-size: 0.3rem;
                            font-weight: bold;
                            color: #3d5aa3;
                        }

                        .line-top {
                            display: flex;
                            width: 4.4rem;
                            height: 0.55rem;
                            background-image: url(../assets/imgs/25/label.png);
                            background-size: 100% 100%;
                            z-index: 99;
                            display: flex;
                            align-items: center;
                            box-sizing: border-box;
                            padding-left: 0.1rem;

                            .line-num {
                                width: 0.44rem;
                                height: 0.44rem;
                                background: #fff;
                                color: #3d5aa3;
                                display: inline-flex;
                                border-radius: 50%;
                                justify-content: center;
                                align-items: center;
                                margin-right: 0.18rem;
                                position: relative;
                                z-index: 3;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                font-size: 0.28rem;
                                font-weight: bold;
                            }
                        }

                        .line-content {
                            //   border-left: 0.02rem dashed #739bfe;
                            padding-bottom: 0.32rem;
                            margin-left: 0.2rem;
                            padding-left: 0.32rem;
                            padding-top: 0.15rem;
                            word-break: break-all;
                            line-height: 0.44rem;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;
          position: relative;
            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .info {
                position: absolute;
                top: 0.26rem;
                left: 0.3rem;
                width: 6.24rem;
                height: 1.94rem;
            }
        }
    }
}
</style>
